import AmityClient, {
    CommunityRepository, getCommunityTopic, EventSubscriberRepository, SubscriptionLevels, PostRepository,
    ApiEndpoint, ApiRegion, FeedType, CommentRepository, ReactionRepository
} from '@amityco/js-sdk';
import { logAPI } from "./andyliticsApi";

const apiKey = typeof window !== 'undefined' ? window.serverData.data.amityApiKey : '';
const communityId = typeof window !== 'undefined' ? window.serverData.data.amityCommunityId : '';
const prayerCommentsMaxLimit = typeof window !== 'undefined' ? window.serverData.data.prayerCommentsMaxLimit : 50;
const apiEndpoint = ApiEndpoint.US;

//export const client = new ASCClient({ apiKey, apiEndpoint });
export const client = new AmityClient({ apiKey, apiRegion: ApiRegion.US });

export const registerSession = (userId, authToken) => {
    client.registerSession({ userId, authToken });
    return client;
};

export const joinCommunity = () => {
    return CommunityRepository.joinCommunity(communityId);
};

export const subscribe = () => {
    try {
        return new Promise((resolve, reject) => {
            const liveObject = CommunityRepository.communityForId(communityId);
            liveObject.once('dataUpdated', community => {
                if (community && community.communityId) {
                    const communityTopic = getCommunityTopic(community, SubscriptionLevels.POST_AND_COMMENT);
                    if (communityTopic) {
                        EventSubscriberRepository.subscribe(communityTopic, subscription => {
                            console.log('subscribing with community topic', subscription);
                            resolve(communityTopic);
                            liveObject.dispose();
                        });
                    }
                }
            });
            liveObject.once('dataError', error => {
                reject(error);
                liveObject.dispose();
            });
        });
    } catch (error) {
        console.log(error);
        return Promise.reject(error);
    }
};

export const queryAllPosts = () => {
    return PostRepository.queryPosts({
        //communityId: communityId,
        targetType: 'community',
        targetId: communityId,
        //feedType: FeedType.Published,
        tags: ['']
    })
};

export const queryPrayerOfTheWeek = () => {
    return PostRepository.queryPosts({
        //communityId: communityId,
        targetType: 'community',
        targetId: communityId,
        //feedType: FeedType.Published,
        tags: ['prayerOfTheWeek']
    });
};

export const getPost = postId => {
    return PostRepository.postForId(postId);
};

export const queryMyPosts = (memberId) => {
    return PostRepository.queryPosts({
        //communityId: communityId,
        targetType: 'community',
        targetId: communityId,
        //feedType: FeedType.Published,
        tags: [memberId.substr(0, 24)]
    })
};

export const postPrayer = (textInput, memberId) => {
    try {
        return new Promise((resolve, reject) => {
            const liveObject = PostRepository.createTextPost({
                targetId: communityId,
                targetType: 'community',
                text: JSON.stringify(textInput),
                tags: [memberId.substr(0, 24), 'prayerOfTheWeek']
            })
            liveObject.once('dataUpdated', data => {
                resolve(data);
                liveObject.dispose();
            });
            liveObject.once('dataError', error => {
                reject(error);
                liveObject.dispose();
            });
        });
    } catch (error) {
        console.log(error);
        return Promise.reject(error);
    }
}

export const editPost = (postId, textInput, memberId) => {
    try {
        return new Promise((resolve, reject) => {
            PostRepository.updatePost({
                postId,
                data: { text: JSON.stringify(textInput) },
                tags: [memberId.substr(0, 24), 'prayerOfTheWeek'],
                metadata: { edited: 'true' }
            }).then(data => {
                resolve(data);
            }).catch(error => {
                reject(error);
            });
            //editPostLiveObject.on('dataUpdated', data => {
            //    resolve(data);
            //    editPostLiveObject.dispose();
            //});
            //editPostLiveObject.on('dataError', error => {
            //    reject(error);
            //    editPostLiveObject.dispose();
            //});
        });
    } catch (error) {
        console.log(error);
        return Promise.reject(error);
    }
};

export const deletePrayer = (postId) => {
    try {
        const response = PostRepository.deletePost(postId, true);
        return response;
    } catch (error) {
        console.log(error);
        return Promise.reject(error);
    }
}

export const notifyDeletedPost = (postedUserId, postId, postTitle, postBody, postCreatedDate, deletedUserId, deletedUserRole, reason) => {
    const url = '/api/Account/NotifyDeletedPost';
    const payload = { postedUserId, postId, postTitle, postBody, postCreatedDate, deletedUserId, deletedUserRole, reason };
    logAPI('Api.PrayerFeature.NotifyDeletedPost.Post', new Date(), url, payload);
    return fetch2(url, '', JSON.stringify(payload), 'POST').then(response => {
        logAPI('Api.PrayerFeature.NotifyDeletedPost.Post.' + (!response.errorMessage ? 'Success' : 'Failure'), new Date(), url, response);
        return response;
    }).catch(err => {
        logAPI("Api.PrayerFeature.NotifyDeletedPost.Post.Failure", new Date(), url, err);
        return err;
    });
};

export const banUser = (userId) => {
    const url = '/api/Account/BanUser';
    logAPI('Api.PrayerFeature.BanUser.Post', new Date(), url, '', userId);
    return fetch2(url, '', JSON.stringify({ userId }), 'POST').then(response => {
        logAPI('Api.PrayerFeature.BanUser.Post.' + (!response || !response.errorMessage ? 'Success' : 'Failure'), new Date(), url, response, userId);
        return response;
    }).catch(err => {
        logAPI("Api.PrayerFeature.BanUser.Post.Failure", new Date(), url, err, userId);
        return err;
    });
};

export const getPrayerReactions = postId => {
    return ReactionRepository.queryReactions({ referenceType: 'post', referenceId: postId });
};

export const addReaction = (postId) => {
    const response = PostRepository.addReaction({ postId, reactionName: 'love' });
    return response;
};

export const removeReaction = (postId) => {
    const response = PostRepository.removeReaction({ postId, reactionName: 'love' });
    return response;
};

export const getComment = commentId => {
    const liveObject = CommentRepository.commentForId(commentId);
    return liveObject;
};

export const queryAllComments = (postId) => {
    return CommentRepository.queryComments({
        referenceType: 'post',
        referenceId: postId,
        isDeleted: false,
        first: prayerCommentsMaxLimit
    });
};

export const addComment = (comment, postId, postUserIdForNotification, moderatorEmail) => {
    try {
        return new Promise((resolve, reject) => {
            const payload = {
                referenceType: 'post', referenceId: postId, text: comment,
                metadata: { role: 'moderator', moderatorEmail }
            }
            if (postUserIdForNotification) {
                payload.metadata = { ...payload.metadata, postUserIdForNotification };
            }
            const liveObject = CommentRepository.createTextComment(payload);
            liveObject.once('dataUpdated', data => {
                resolve(data);
                liveObject.dispose();
            });
            liveObject.once('dataError', error => {
                reject(error);
                liveObject.dispose();
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

export const editComment = (commentId, textInput) => {
    try {
        return new Promise((resolve, reject) => {
            try {
                const liveObject = CommentRepository.editTextComment({
                    commentId: commentId,
                    text: textInput,
                });
                resolve(liveObject);
            } catch (error) {
                reject(error);
                console.log('Cannot edit comment', error);
            }
            /*liveObject.on('dataUpdated', data => {
                resolve(data);
                liveObject.dispose();
            });
            liveObject.on('dataError', error => {
                reject(error);
                liveObject.dispose();
            });*/
        });
    } catch (error) {
        return Promise.reject(error);
    }
};

export const deleteComment = (commentId) => {
    const response = CommentRepository.deleteComment(commentId, true);
    return response;
};

export const addCommentReaction = (commentId) => {
    return CommentRepository.addReaction({
        commentId,
        reactionName: 'love',
    });
};

export const removeCommentReaction = (commentId) => {
    return CommentRepository.removeReaction({
        commentId,
        reactionName: 'love',
    });
};

export const getUsersDeletedPosts = () => {
    const url = '/api/UsersDeletedPosts';
    return fetch2(url).then(response => {
        return response;
    }).catch(err => {
        console.log("err",err);
        return err;
    });
};